module.exports = __webpack_public_path__ + "static/media/Instagram.d4ec3d2d.svg";